import React from 'react';
import { PdfTemplateContext, PdfTemplateContextProps } from '../context/PdfTemplateContext';
import { PdfTemplate } from '../types/pdf_template';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 } from 'uuid';

const pdfTemplateState = {
  items: new Map<string, PdfTemplate>(),
  loading: false,
};

export const pdfTemplateSlice = createSlice({
  name: 'pdfTemplate',
  initialState: { key: v4() },
  reducers: {
    reset: state => {
      pdfTemplateState.items = new Map();
      pdfTemplateState.loading = true;
      state.key = v4();
    },
    set: (state, action: PayloadAction<PdfTemplate[]>) => {
      pdfTemplateState.items = new Map();
      action.payload.forEach(p => pdfTemplateState.items.set(p.id, new PdfTemplate(p)));
      state.key = v4();
    },
    add: (state, action: PayloadAction<PdfTemplate[]>) => {
      action.payload.forEach(p => pdfTemplateState.items.set(p.id, new PdfTemplate(p)));
      pdfTemplateState.items = new Map(pdfTemplateState.items);
      state.key = v4();
    },
    delete: (state, action: PayloadAction<PdfTemplate[]>) => {
      action.payload.forEach(p => pdfTemplateState.items.delete(p.id));
      pdfTemplateState.items = new Map(pdfTemplateState.items);
      state.key = v4();
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      pdfTemplateState.loading = action.payload;
      state.key = v4();
    },
  },
});

interface PdfTemplateProviderProps {
  children: React.ReactNode;
}

export default function PdfTemplateProvider({ children }: PdfTemplateProviderProps) {
  const dispatch = useAppDispatch();
  const key = useAppSelector(state => state.pdfTemplates.key);

  const pmdContext: PdfTemplateContextProps = {
    pdfTemplates: pdfTemplateState.items,
    pdfTemplatesLoading: pdfTemplateState.loading,
    setPdfTemplates: (pmd: Map<string, PdfTemplate>) => {
      dispatch(pdfTemplateSlice.actions.set([...pmd.values()]));
    },
  };

  return <PdfTemplateContext.Provider value={pmdContext}>{children}</PdfTemplateContext.Provider>;
}
